import { useNavigate } from "react-router-dom"
import { PATH_INFO } from "../util/helper"
import { Button, Flex, Result } from "antd"
import { useTranslation } from "react-i18next"

export function ErrorPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const handleBackHome = () => { navigate(PATH_INFO.COMPANY_LIST.PATH) }

  return (
    <Flex align="center" justify="center" style={{ height: 'calc(100vh - 200px)' }}>
      <Result
        status='error'
        title={t("common.error")}
        extra={
          <Button type='primary' onClick={handleBackHome}>
            {t("pages.homeBack")}
          </Button>
        }
      />
    </Flex>
  )
}
